import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { CircleAlertIcon } from "../../../../../../components/Icons";

const PrescriptionsLimitMessage = () => {
  const theme = useTheme();

  return (
    <Box className="flex items-center gap-2 mt-2">
      <CircleAlertIcon width={20} height={20} color={theme.palette.warning.dark} />
      <Typography variant="body2" color="black.main" className="w-full">
        At the moment, this is the maximal number of items we can show. If you have more than 100 prescriptions, filter
        the list by pet&apos;s name to get better results.
      </Typography>
    </Box>
  );
};

export default PrescriptionsLimitMessage;
